<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
      <AddressForm
        ref="addressForm"
        @handleAddressTypeChange="handleAddressTypeChange"
      />
      <ContactsForm ref="contactsForm" />
      <InstructionsForm ref="instructionsForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import AddressForm from './address';
import ContactsForm from './contacts';
import InstructionsForm from './instructions';
import SubBtnBox from 'components/subBtnBox';
import {
  cityAddressSaveOrUpdate,
  queryByAfId,
} from 'api/distribution';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    AddressForm,
    ContactsForm,
    InstructionsForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/distribution/addressArchives/edit',
      formComponents: ['baseForm', 'addressForm', 'contactsForm', 'instructionsForm'],

      // 需要对比的参数
      compareParams: {
        customerId: '',
        consignee: '',
        addressType: '',
        addressNavigationLat: '',
        addressNavigationLng: '',
        estimatedStayTime: '',

        linkMan1: '',
        linkManPhone1: '',
        linkMan2: '',
        linkManPhone2: '',

        opRemarks: '',
      },
    };
  },
  computed: {
    editParams () {
      let parmas = {};
      if (this.$route.query.id) {
        parmas.afId = this.$route.query.id;
      }
      return parmas;
    },
    detailParams () {
      return {
        afId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: queryByAfId,
    editApi: cityAddressSaveOrUpdate,
    handleAddressTypeChange (addressType) {
      if (this.$refs.baseForm && this.$refs.baseForm.handleAddressTypeChange) {
        this.$refs.baseForm.handleAddressTypeChange(addressType);
      }
    },
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
